import React from "react";
import TabellaClassiMacrocategorieView from "./TabellaClassiMacrocategorieView";

export default function TabellaClassiMacrocategorieController({
                                                        classiMacrocategorie,
                                                        translate,
                                                        setClasseMacrocategoriaSel,
                                                        setShowConfirm,
                                                        history,
                                                    }) {

    function onClickElimina(row) {
        setClasseMacrocategoriaSel(row);
        setShowConfirm(true);
    }

    function onRowDbClick(row) {
        history.push("/upd-classe-macrocategoria/" + row.id_classe_macrocategoria);
    }

    return (
        <TabellaClassiMacrocategorieView
            translate={translate}
            classiMacrocategorie={classiMacrocategorie}
            onClickElimina={onClickElimina}
            onRowDbClick={onRowDbClick}
        />
    );
}